<template>
  <div>
    <div class="col-lg-3">
      <button class="mylisting-button dark-button" @click="showNewFooterModal()">Add New Footer</button>
    </div>
    <hr>
    <div v-for="footer in footers" :key="footer.id">
      <div class="row">
        <div class="col-lg-3" style="max-width: 180px; border-right: 1px solid var(--coredarkcolor)">
          <img :src="footer.image" style="max-width: 150px; border-radius: 50%;">
        </div>
        <div class="col-lg-3">
          <h3>{{ footer.name }}</h3>
          <p>{{ footer.title }}</p>
          <p> {{ footer.email }} </p>
          <p> {{ footer.phone }} </p>
          <p> {{ footer.address }} </p>
        </div>
        <div class="col-lg-3" style="padding-top:30px;">
          <p>{{ footer.facebook }}</p>
          <p>{{ footer.instagram }}</p>
          <p> {{ footer.twitter }} </p>
          <p> {{ footer.linkedin }} </p>
          <p> {{ footer.youtube }} </p>
          <p> {{ footer.website }} </p>
        </div>
        <div class="col-lg-2" style="display:flex; justify-content:center; align-items:center;">
          <button class="mylisting-button dark-button" @click="showEditModal(footer)">Edit</button>
        </div>
      </div>
    </div>

    <modal name="new-footer-modal" width="40%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <label for="" class="form-control-label">Please select a user to create an email footer for:</label>
        <multiselect class="mb-3" v-model="email" :options="emails" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
        <p class="required-message" v-if="!email && submitClicked">Please select an email to continue.</p>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('new-footer-modal')">Cancel</button>
        <button class="mylisting-button dark-button" style="" @click="showAddModal()">Next</button>
      </div>
    </modal>

    <modal name="create-footer-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <label style="margin-bottom: 0;">Email</label>
        <input type="text" class="form-control mb-2" v-model="email" placeholder="">
        <hr>
        <div class="row">
          <div class="col-lg-4">
            <label for="">Name: </label>
            <input type="text" class="form-control" v-model="name">
            <label style="margin-bottom: 0;">Title</label>
            <input type="text" class="form-control mb-2" v-model="title" placeholder="">
            <label style="margin-bottom: 0;">Phone</label>
            <input type="text" class="form-control mb-2" v-model="phone" placeholder="">
            <label style="margin-bottom: 0;">Address</label>
            <input type="text" class="form-control mb-2" v-model="address" placeholder="">
          </div>
          <div class="col-lg-4">
            <label style="margin-bottom: 0;">Facebook</label>
            <input type="text" class="form-control mb-2" v-model="facebook" placeholder="">
            <label style="margin-bottom: 0;">Instagram</label>
            <input type="text" class="form-control mb-2" v-model="instagram" placeholder="">
            <label style="margin-bottom: 0;">Twitter</label>
            <input type="text" class="form-control mb-2" v-model="twitter" placeholder="">
          </div>
          <div class="col-lg-4">
            <label style="margin-bottom: 0;">LinkedIn</label>
            <input type="text" class="form-control mb-2" v-model="linkedin" placeholder="">
            <label style="margin-bottom: 0;">YouTube</label>
            <input type="text" class="form-control mb-2" v-model="youtube" placeholder="">
            <label style="margin-bottom: 0;">Website</label>
            <input type="text" class="form-control mb-2" v-model="website" placeholder="">
          </div>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('create-footer-modal')">Cancel</button>
        <button class="mylisting-button dark-button" style="" @click="saveNewFooter()">Save</button>
      </div>
    </modal>

    <modal name="new-created-modal" width="40%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>New footer created!</h4>
        <hr>
        <button class="mylisting-button dark-button" @click="$modal.hide('new-created-modal')">Close</button>
      </div>
    </modal>

    <modal name="footer-edit-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <label for="">Name: </label>
        <input type="text" class="form-control" v-model="name">
        <hr>
        <div class="row">
          <div class="col-lg-4">
            <label style="margin-bottom: 0;">Title</label>
            <input type="text" class="form-control mb-2" v-model="title" placeholder="">
            <label style="margin-bottom: 0;">Email</label>
            <input type="text" class="form-control mb-2" v-model="email" placeholder="">
            <label style="margin-bottom: 0;">Phone</label>
            <input type="text" class="form-control mb-2" v-model="phone" placeholder="">
            <label style="margin-bottom: 0;">Address</label>
            <input type="text" class="form-control mb-2" v-model="address" placeholder="">
          </div>
          <div class="col-lg-4">
            <label style="margin-bottom: 0;">Facebook</label>
            <input type="text" class="form-control mb-2" v-model="facebook" placeholder="">
            <label style="margin-bottom: 0;">Instagram</label>
            <input type="text" class="form-control mb-2" v-model="instagram" placeholder="">
            <label style="margin-bottom: 0;">Twitter</label>
            <input type="text" class="form-control mb-2" v-model="twitter" placeholder="">
          </div>
          <div class="col-lg-4">
            <label style="margin-bottom: 0;">LinkedIn</label>
            <input type="text" class="form-control mb-2" v-model="linkedin" placeholder="">
            <label style="margin-bottom: 0;">YouTube</label>
            <input type="text" class="form-control mb-2" v-model="youtube" placeholder="">
            <label style="margin-bottom: 0;">Website</label>
            <input type="text" class="form-control mb-2" v-model="website" placeholder="">
          </div>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('footer-edit-modal')">Cancel</button>
        <button class="mylisting-button dark-button" style="" @click="saveChanges()">Save</button>
      </div>
    </modal>

    <modal name="saved-modal" width="40%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Changes saved!</h4>
        <hr>
        <button class="mylisting-button dark-button" @click="$modal.hide('saved-modal')">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      footers: [],
      footer: {},
      userList: [],
      emails: [],

      id: null,
      name: '',
      image: '',
      title: '',
      email: '',
      phone: '',
      address: '',
      facebook: '',
      instagram: '',
      linkedin: '',
      twitter: '',
      website: '',
      youtube: '',
      footerID: null,

      submitClicked: false,
    }
  },
  created() {
    this.getFooters()
    this.getAdmins()
  },
  methods: {
    getFooters() {
      axios.get(`/api/emailfooters/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          this.footers = res.data
        })
        .catch(error => console.log(error))
    },
    // Get all admin accounts related to the company
    getAdmins() {
      axios.get('/api/people/', {
        params: {
          agency: this.$store.getters.agencyID,
          is_agent: true
        }
      })
        .then(res => {
          this.userList = res.data

          // Put all admin emails into a list
          this.userList.forEach(user => {
            this.emails.push(user.email)
          })
        })
        .catch(error => console.log(error))
    },
    showNewFooterModal() {
      this.$modal.show('new-footer-modal')
    },
    showAddModal() {
      this.submitClicked = true
      // Once user picks an email from the list, populate the form with data from the admin's profile
      if (this.email) {
        for (let user in this.userList) {
          if (this.userList[user].email == this.email) {
            console.log(this.userList[user].phone)
            this.name = this.userList[user].first_name + this.userList[user].last_name
            this.id = this.userList[user].id
            this.image = this.userList[user].profile_pic
            this.title = this.userList[user].title
            this.phone = this.userList[user].phone
            this.address = `${this.userList[user].address1}, ${this.userList[user].city}, ${this.userList[user].provincestate}`
            this.facebook = this.userList[user].facebook
            this.instagram = this.userList[user].instagram
            this.twitter = this.userList[user].twitter
            this.linkedin = this.userList[user].linkedin
            this.youtube = this.userList[user].youtube
            this.website = this.userList[user].website
          }
        }
        this.$modal.hide('new-footer-modal')
        this.$modal.show('create-footer-modal')
      }
    },
    saveNewFooter() {
      axios.post(`/api/emailfooters/`, {
        name: this.name,
        id: this.id,
        image: this.image,
        email: this.email,
        title: this.title,
        phone: this.phone,
        address: this.address,
        facebook: this.facebook,
        instagram: this.instagram,
        twitter: this.twitter,
        linkedin: this.linkedin,
        youtube: this.youtube,
        website: this.website,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName,
      })
      this.$modal.hide('create-footer-modal')
      this.$modal.show('new-created-modal')
      this.getFooters()
    },
    showEditModal(footer) {
      this.footer = footer
      this.name = this.footer.name
      this.title = this.footer.title
      this.email = this.footer.email
      this.phone = this.footer.phone
      this.address = this.footer.address
      this.facebook = this.footer.facebook
      this.instagram = this.footer.instagram
      this.twitter = this.footer.twitter
      this.linkedin = this.footer.linkedin
      this.youtube = this.footer.youtube
      this.website = this.footer.website
      this.footerID = this.footer.id
      this.$modal.show('footer-edit-modal')
    },
    saveChanges() {
      axios.patch(`/api/emailfooters/?id=${this.footerID}/`, {
        name: this.name,
        title: this.title,
        email: this.email,
        phone: this.phone,
        address: this.address,
        facebook: this.facebook,
        instagram: this.instagram,
        twitter: this.twitter,
        linkedin: this.linkedin,
        youtube: this.youtube,
        website: this.website,
      })
      this.$modal.hide('footer-edit-modal')
      this.$modal.show('saved-modal')
      this.getFooters()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/systems/EmailFooters.vue